import React from 'react';
import { Helmet } from 'react-helmet';

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Sarah Johnson',
      position: 'Founder and CEO',
      bio: 'Former professional athlete with 15 years of experience in health and wellness industry',
      image: '/images/team_1.jpg'
    },
    {
      id: 2,
      name: 'Emma Williams',
      position: 'Head Nutritionist',
      bio: 'Certified nutritionist specializing in sports nutrition and dietary supplements',
      image: '/images/team_2.jpg'
    },
    {
      id: 3,
      name: 'David Thompson',
      position: 'Product Development Manager',
      bio: 'Expert in fitness equipment design with background in biomechanics',
      image: '/images/team_3.jpg'
    },
    {
      id: 4,
      name: 'Lisa Anderson',
      position: 'Customer Success Director',
      bio: 'Dedicated to ensuring every customer achieves their wellness goals',
      image: '/images/team_4.jpg'
    },
    {
      id: 5,
      name: 'Michael Brown',
      position: 'Quality Assurance Lead',
      bio: 'Ensures all products meet the highest standards of quality and safety',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <div className="about-container">
      <Helmet>
        <title>About Us - Fitness Health Blog Team</title>
        <meta name="description" content="Meet the Fitness Health Blog team dedicated to providing premium wellness products and supporting your fitness journey" />
        <meta property="og:title" content="About Fitness Health Blog" />
        <meta property="og:description" content="Learn about our mission to provide premium fitness and health products" />
      </Helmet>

      <h1>About Fitness Health Blog</h1>

      <div className="about-content">
        <h2>Our Story</h2>
        <p>
          Fitness Health Blog was founded in 2017 with a simple yet powerful mission: to make premium quality fitness 
          and health products accessible to everyone in the United Kingdom. What started as a small passion project 
          has grown into a trusted name in the wellness industry, serving over 15000 satisfied customers.
        </p>

        <p>
          Our founder, Sarah Johnson, a former professional athlete, recognized the gap in the market for authentic, 
          high-quality wellness products. She assembled a team of experts passionate about health and fitness to create 
          a company that truly understands and serves the needs of active individuals.
        </p>

        <h2>Our Mission</h2>
        <p>
          We are committed to providing our customers with the finest quality fitness and health products that support 
          their wellness journeys. Every product we offer is carefully selected, rigorously tested, and backed by our 
          quality guarantee. We believe that everyone deserves access to premium wellness products that are both 
          effective and safe.
        </p>

        <h2>Our Values</h2>
        <p>
          Quality is at the heart of everything we do. We partner only with trusted manufacturers who share our commitment 
          to excellence. Transparency guides our business practices - from clear ingredient lists to honest product 
          descriptions. Customer satisfaction drives our innovation and growth. We are dedicated to supporting your 
          wellness journey every step of the way.
        </p>

        <h2>Why Choose Us</h2>
        <p>
          With over 8 years of experience in the health and wellness industry, we have built a reputation for reliability 
          and excellence. Our products are certified by leading health organizations and undergo rigorous third-party 
          testing. We offer fast delivery across the United Kingdom, competitive pricing, and exceptional customer service. 
          Join our community of satisfied customers who trust us for their fitness and health needs.
        </p>
      </div>

      <section className="team-section">
        <h2>Meet Our Team</h2>
        <div className="team-grid">
          {teamMembers.map(member => (
            <div key={member.id} className="team-member">
              <img 
                src={member.image} 
                alt={'Team member ' + member.id}
                width="400"
                height="400"
              />
              <h3>{member.name}</h3>
              <p>{member.position}</p>
              <p>{member.bio}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default About;